import styled, { css } from "styled-components";
import { Spin as SpinAntd } from "antd";

interface SectionEditProps {
  active: boolean;
}

export const Container = styled.div`
  height: 100%;
  position: relative;
`;

export const HeaderPage = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0;

  svg {
    width: 18px;
    height: 18px;
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.primary};
  }

  > div {
    padding-left: 0;
  }

  @media (min-width: 768px) {
    padding: 0 2rem;
  }
`;

export const ContentAnimals = styled.div``;

export const SectionEdit = styled.button<SectionEditProps>`
  ${({ theme, active }) => css`
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    background-color: transparent;
    border: 0;

    > svg {
      color: ${active ? theme.colors.orange : theme.colors.primary};
    }

    span {
      display: block;
      padding-left: 0.5rem;
      color: ${active ? theme.colors.orange : theme.colors.primary};
    }
  `}
`;

export const Spin = styled(SpinAntd)`
  margin: 0 auto;
  width: 100%;
  color: ${({ theme }) => theme.colors.primary} !important;
  font-size: 1rem;
  margin-top: 1rem;

  .ant-spin-dot-item {
    background-color: ${({ theme }) => theme.colors.primary} !important;
  }
`;
